import * as React from 'react';
import styled from '@emotion/styled';
const VIEWBOX_BASE_WIDTH = 16;
const STYLES = {
    small: {
        height: '8px',
    },
    regular: {
        height: '16px',
    },
    large: {
        height: '32px',
    },
};
export const StyledSVG = styled.svg `
	${({ size }) => STYLES[size]};
`;
export const Star = ({ fillAmount, lhsColor, rhsColor, truncateViewBox, size = 'regular' }) => {
    const percentStarFill = `${fillAmount * 100}%`;
    const viewBoxWidth = truncateViewBox ? VIEWBOX_BASE_WIDTH * fillAmount : VIEWBOX_BASE_WIDTH;
    const maskId = React.useId();
    return React.createElement(StyledSVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: `0 0 ${viewBoxWidth} 16`, size: size },
        React.createElement("defs", null,
            React.createElement("linearGradient", { id: maskId, x1: "0%", y1: "0%", x2: "100%", y2: "0%" },
                React.createElement("stop", { offset: percentStarFill, stopColor: lhsColor, "data-testid": "star-lhs" }),
                React.createElement("stop", { offset: percentStarFill, stopColor: rhsColor, "data-testid": "star-rhs" })),
            React.createElement("symbol", { xmlns: "http://www.w3.org/2000/svg", viewBox: `0 0 ${viewBoxWidth} 16`, id: `star-${maskId}` },
                React.createElement("path", { d: "M7.18512 0.619069C7.44161 -0.206356 8.55839 -0.206356 8.81488 0.619069L10.116 4.80641C10.2307 5.17555 10.5597 5.42548 10.9309 5.42548H15.1415C15.9716 5.42548 16.3167 6.53608 15.6452 7.04622L12.2387 9.63414C11.9384 9.86228 11.8127 10.2667 11.9274 10.6358L13.2286 14.8232C13.4851 15.6486 12.5816 16.335 11.9101 15.8248L8.50362 13.2369C8.20332 13.0088 7.79668 13.0088 7.49638 13.2369L4.08991 15.8248C3.41841 16.335 2.51492 15.6486 2.7714 14.8232L4.07256 10.6358C4.18727 10.2667 4.06161 9.86228 3.7613 9.63414L0.354834 7.04622C-0.316663 6.53608 0.0284404 5.42548 0.858457 5.42548H5.06909C5.44028 5.42548 5.76926 5.17555 5.88397 4.80641L7.18512 0.619069Z" }))),
        React.createElement("use", { xlinkHref: `#star-${maskId}`, fill: `url(#${maskId})` }));
};
//# sourceMappingURL=Star.js.map